import { Link, useLoaderData } from "react-router-dom";
import ServerFooter from "src/components/common/ServerFooter";
import { record } from "../types";
interface LoaderData {
    records: record[];
    total: number;
    formName: string;
    formType: string;
}
export default function FormRecords() {
    const {
        records,
        total,
        formName, 
        formType,
    } = useLoaderData() as LoaderData;
    return (
        <div className = "cssContent pb8rem">
        <div className = "d-flex align-items-center justify-content-between my-3">
            <div>
            <h3 className = "mb-0">
                {formName}
                <span className = "text-muted ms-2 fw-normal">
                ({formType})
                </span>
            </h3>
            <div className = "text-muted">
                Submissions
            </div>
            </div>

            <div>
            <Link
                to = "Add"
                className = "btn btn-outline-primary me-3"
            >
                Add
            </Link>
            <Link
                to = ".."
                className = "btn btn-outline-secondary"
            >
                Back
            </Link>
            </div>
        </div>
        {records.length === 0 ? (
            <div className = "alert alert-info">
            No submissions yet.
            </div>
        ) : (
            <>
            <table className = "table table-striped">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Created</th>
                    <th>Updated</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {records.map(reocrd => (
                    <tr key = {reocrd.id}>
                    <td>{reocrd.id}</td>
                    <td>{reocrd.name}</td>
                    <td>{reocrd.createdAt}</td>
                    <td>{reocrd.updatedAt}</td>
                    <td>
                        <Link
                            children = "Detail"
                            to = {`${reocrd.id}`}
                            className = "btn btn-outline-primary me-3"
                        />
                    </td>
                    </tr>
                ))}
                </tbody>
            </table>
            {total>0?<ServerFooter length = {total}/>:null}
            </>
        )}
        </div>
    );
}